import { Tag } from 'antd'
import dayjs from 'dayjs'
import { InvoiceSummary } from '../../../domain/invoicing/invoice'

type Props = {
  invoiceSummary: InvoiceSummary
}

const formatSentAt = (iso: string | null) => iso ? dayjs(iso).format('MMM D, YYYY') : null

export const EmailStatusDisplay = ({ invoiceSummary }: Props) => {
  const sentAt = formatSentAt(invoiceSummary.emailSentAt)

  if (invoiceSummary.invoicingSystem === 'synkedUp') {
    if (invoiceSummary.wasEmailSent) {
      return <SentTag sentAt={sentAt} />
    }
    return <Tag color="error">Not Sent</Tag>
  }

  switch (invoiceSummary.qboEmailStatus) {
    case 'Sent':
      return <SentTag sentAt={sentAt} />
    case 'NotSet':
      return <Tag color="error">Not Sent</Tag>
    case 'NeedToSend':
      return <Tag color="warning">Need to Send</Tag>
    default:
      return <Tag>{invoiceSummary.qboEmailStatus}</Tag>
  }
}

const SentTag = ({ sentAt }: { sentAt: string | null }) => (
  <div style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'flex-start', gap: 2 }}>
    <Tag color="success" style={{ margin: 0 }}>Sent</Tag>
    {sentAt && <span style={{ fontSize: 12, color: 'rgba(0, 0, 0, 0.45)' }}>{sentAt}</span>}
  </div>
)
